module.exports = __webpack_public_path__ + "img/tab_item03.0acf382e.png";